import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth-guard';

export const routes: Routes = [
  // Public routes
  {
    path: 'login',
    title: 'Iniciar Sesión | Conteo',
    loadComponent: () => import('./features/login/login').then(m => m.Login),
  },
  {
    path: 'welcome',
    redirectTo: '/login',
    pathMatch: 'full',
  },

  // Protected routes — authGuard verifies session + role only
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shared/layout/layout').then(m => m.Layout),
    children: [
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then(m => m.HOME_ROUTES),
      },
      {
        path: 'takes',
        loadChildren: () => import('./features/takes/takes.routes').then(m => m.TAKES_ROUTES),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./features/products/products.routes').then(m => m.PRODUCTS_ROUTES),
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('./features/locations/locations.routes').then(m => m.LOCATIONS_ROUTES),
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./features/warehouse/warehouse.routes').then(m => m.WAREHOUSE_ROUTES),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.USERS_ROUTES),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },

  // Fallback
  {
    path: '**',
    redirectTo: '/login',
  },
];
